import { render, staticRenderFns } from "./Nginx.vue?vue&type=template&id=40e495ab&scoped=true&"
import script from "./Nginx.vue?vue&type=script&lang=js&"
export * from "./Nginx.vue?vue&type=script&lang=js&"
import style0 from "./Nginx.vue?vue&type=style&index=0&id=40e495ab&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e495ab",
  null
  
)

export default component.exports